import moment from 'moment-timezone'
import parsePhoneNumber, { PhoneNumber } from 'libphonenumber-js'
import { LOCAL_STORAGE_KEYS } from '../configs/constants'

export const formatDate = (date: string) => moment(date).format('MM/DD/YYYY')
export const formatTime = (date?: string) => moment(date).format('hh:mm A')

export const formatDateTimeUS = (date: string) => moment(date).format('MM/DD/YYYY hh:mm A')

export const stringifyError = (error: any) => {
  if (error.error) return error.error
  if (error.title || error.body) return `${error.title} ${error.body}`
  if (typeof error === 'string') return error
  return 'Something went wrong'
}

export const etaMinToTime = (etaMin: number | null) => {
  if (etaMin === null) return ''
  if (etaMin === 0) return '0 min'
  const hours = Math.floor(etaMin / 60)
  const minutes = etaMin % 60
  if (hours === 0) return `${minutes} min`
  return `${hours} h ${minutes} min`
}

export const formatPhoneNumber = (phoneNumberString: string | null): string | null => {
  if (!phoneNumberString) return 'N/A'

  let phoneNumber = phoneNumberString.replace(/\D/g, '')

  if (phoneNumber.startsWith('1')) {
    phoneNumber = phoneNumber.substring(1)
  }

  if (phoneNumber.startsWith('3') && phoneNumber.length === 12) {
    phoneNumber = phoneNumber.substring(2)
  }

  phoneNumber.startsWith('0') ? phoneNumber = `+38${phoneNumber}` : phoneNumber = `+1${phoneNumber}`

  const parsedPhoneNumber: PhoneNumber | undefined = parsePhoneNumber(phoneNumber)

  if (parsedPhoneNumber?.isValid()) {
    return parsedPhoneNumber.country === 'UA'
      ? parsedPhoneNumber.formatInternational()
      : `+${parsedPhoneNumber.countryCallingCode} ${parsedPhoneNumber.formatNational()}`
  }

  return phoneNumberString
}

export const getUserFromLocalStorage = () => {
  try {
    const appStorage = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.APP_STORAGE) || '')
    return appStorage?.state?.user || null
  } catch (error) {
    console.error('Error parsing app storage:', error)
    return null
  }
}
